<template>
   <vue-final-modal
      v-model="DrugsModal" 
      @click-outside="$emit('cancel')"
      classes="modal-container"
      content-class="v310-modal-content"
      :focus-trap="true"
      >
   <div class=" container text-center">
      <div v-if="true" class="row up-voucher rounded-2">
         <br>
         {{prescriptionData}}
         <br>
         <div tabindex="1" onfocus="document.getElementById('last').focus()"></div>
         <div v-if="true">
            <input id="first" tabindex="2" ref="fDisease" v-model="diseaseValue" autofocus name="disease" type="text" @keyup.enter="validDisease(diseaseValue)"/>
         </div>
         <div v-if="true">
            <input tabindex="3"  ref="fDrug" v-model="drugValue" name="drug" type="text" @keyup.enter="validDrug(drugValue)"/>
            <input tabindex="4" ref="fDose" v-model="doseValue" name="dose" type="text" @keyup.enter="validDose(doseValue)"/>
         </div>
         <div tabindex="5" onfocus="document.getElementById('first').focus()"></div>
      </div>
   </div>
   <!--
         <div v-if="!showDrug">
   <div>{{showData}}</div>
   -->
   </vue-final-modal>
</template>

<script setup>
import { ref, onMounted, nextTick, getCurrentInstance } from 'vue';
import { VueFinalModal } from 'vue-final-modal'
//import { Field, useForm, useFieldArray } from 'vee-validate';
import { useField } from 'vee-validate';

const { emit } = getCurrentInstance()
//const emit = defineEmits(['outHere'])
const prescriptionData = ref({})
const drugsData = ref([])
const fDisease = ref(null)
const fDrug = ref(null)
const fDose = ref(null)
const showDrug = ref(false)

const DrugsModal = ref(true)

const validDisease = (value) => {
   console.log(value)
   if ( value == undefined || value.trim() == '' ) {
      console.log(value)
      emit('outHere')
   } else {
      prescriptionData.value = {disease: value}
      showDrug.value = true
      nextTick(() => {
         fDrug.value.focus()
      })
   }
}

const validDrug = (value) => {
   console.log(value)
   if ( value == undefined || value.trim() == '' ) {
      console.log(value)
      prescriptionData.value = {}
      showDrug.value = false
      nextTick(() => {
         diseaseValue.value = ''
         fDisease.value.focus()
      })
   } else {
         fDose.value.focus()
   }
}

const validDose = (value) => {
   console.log(value)
   if ( value == undefined || value.trim() == '' ) {
      console.log(value)
         fDose.value.focus()
   } else {
      drugsData.value.push({
         drug: drugValue.value,
         dose: value
         })
      drugValue.value = ''
      doseValue.value = ''
      prescriptionData.value = {
         disease: diseaseValue.value,
         drugs: drugsData.value
         }
      fDrug.value.focus()
   }
}

const { 
   value: diseaseValue} = useField('disease');
   //errorMessage: diseaseErrorMessage,
   //meta: diseaseMeta} = useField('disease');
//   meta: diseaseMeta} = useField('disease', inputValue => !!inputValue);
const { value: drugValue } = useField('drug');
const { value: doseValue } = useField('dose');

onMounted(() => {
   fDisease.value.focus()
})
/*
export default {
   name: 'UpVoucher310',

   setup() {

      const data = ref('peter')

      return {
         data
      }
   }
}
*/
</script>

<style scoped>
   .up-voucher {
      background-color: #9E9E9E ;
      /*
      margin-top: 100px ;
      max-width: 480px;
      max-height: calc(100vh - 28px);
      overflow-y: auto;
      */
      color: white;
   }
   .tx-cl-white {
      color: white;
   }
</style>